"use client";
import React,{useState} from 'react'
import { ProductProvider } from '../components/Productcontext'
import Producthomecontent from '../components/Producthomecontent'
import Footer from '../components/Footer'
import PreHeader from '../components/PreHeader';
import Header from '../components/Header';
import Menu from '../components/Menu';
import  Franklynpentacontent from '../components/Franklynpentacontent';
import InstallationBanner from '../components/InstallationBanner';
import ProductsubMenu from '../components/ProductsubMenu';
import LightningProductsSubMenu from '../components/LightningProductsSubMenu';

import frank from '../images/franklynpenta/franklyn_page_banner.jpg';
import frank_360 from '../images/franklynpenta/franklyn_page_banner_360.jpg';
import frank_tab from '../images/franklynpenta/franklyn_page_banner_tab.jpg';
import frank2x from  '../images/franklynpenta/franklyn_page_banner@2x.jpg';

// import ban1x from '../images/producthome/product-home-banner.jpg';
// import ban2x from '../images/producthome/product-home-banner@2x.jpg';
const FranklynPage = () => {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    //setIpageValue(item);
    //console.log("set new ipaf vale "+item);
    
  };

    return (
      <div>
           <ProductProvider>
          {/* <PreHeader/>
          <Header/>    
           <Menu/> */}
           <InstallationBanner page="installation" banalt="Ashlok Safe Earthing Electrode Limited - Franklyn Penta Lightning Rod for conventional lightning protection systems" ashlokAfter="" ban1x={frank} ban2x={frank2x} ban360={frank_360} bantab={frank_tab}/>
            <ProductsubMenu/>
            <LightningProductsSubMenu onImageClick={handleItemClick }/>
          
          <Franklynpentacontent/>
           
           <Footer/>
           </ProductProvider>
      </div>
    )
  }
  
  export default FranklynPage
 
